import React, { type Context, type ReactNode, createContext } from "react";
import {
  DropdownMenu,
  DropdownToggle,
  Nav,
  UncontrolledDropdown,
} from "reactstrap";

export const MenuNavDepthContext: Context<number> = createContext(0);

export interface IMenuNavProps {
  depth?: number;
  align?: "center" | "left" | "right";
  toggleClassName?: string;
  toggleLabel?: ReactNode;
  children?: ReactNode;
}

export const MenuNav = ({
  children,
  depth = 0,
  align,
  toggleClassName,
  toggleLabel,
}: IMenuNavProps) => {
  return (
    <MenuNavDepthContext.Provider value={depth + 1}>
      {depth !== 0 ? (
        <UncontrolledDropdown nav inNavbar>
          <DropdownToggle
            nav
            caret={false}
            className={toggleClassName || undefined}
          >
            {toggleLabel || null}
          </DropdownToggle>
          <DropdownMenu>{children}</DropdownMenu>
        </UncontrolledDropdown>
      ) : (
        <Nav
          navbar
          className={align !== "center" ? `pull-md-{align}` : "mx-auto"}
        >
          {children}
        </Nav>
      )}
    </MenuNavDepthContext.Provider>
  );
};
